"use strict";

exports.__esModule = true;
exports.LOG_PREFIX = 'pjs_';
exports.METRICS_CATEGORY = 'pluginJs';